/* @generated from adl module ferovinum.app.tradesale */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as ferovinum_app_db from './db';

export interface TradeSaleAction_Cancelled {
  kind: 'cancelled';
}
export interface TradeSaleAction_Deleted {
  kind: 'deleted';
}
export interface TradeSaleAction_Purchaser_accepted {
  kind: 'purchaser_accepted';
  value: (CollectionDetails|null);
}
export interface TradeSaleAction_Purchaser_rejected {
  kind: 'purchaser_rejected';
}
export interface TradeSaleAction_Delivery_order_requested {
  kind: 'delivery_order_requested';
}
export interface TradeSaleAction_Delivery_order_signed {
  kind: 'delivery_order_signed';
}
export interface TradeSaleAction_Production_order_complete {
  kind: 'production_order_complete';
}
export interface TradeSaleAction_Ready_for_collection {
  kind: 'ready_for_collection';
}
export interface TradeSaleAction_Collected {
  kind: 'collected';
  value: common.LocalDate;
}
export interface TradeSaleAction_Delivered {
  kind: 'delivered';
  value: common.LocalDate;
}
export interface TradeSaleAction_Purchaser_invoiced {
  kind: 'purchaser_invoiced';
  value: common_db.DbKey<ferovinum_app_db.Invoice>;
}
export interface TradeSaleAction_Purchaser_paid {
  kind: 'purchaser_paid';
  value: PurchaserPaymentInfo;
}
export interface TradeSaleAction_Paid_organisation {
  kind: 'paid_organisation';
  value: common.LocalDate;
}

export type TradeSaleAction = TradeSaleAction_Cancelled | TradeSaleAction_Deleted | TradeSaleAction_Purchaser_accepted | TradeSaleAction_Purchaser_rejected | TradeSaleAction_Delivery_order_requested | TradeSaleAction_Delivery_order_signed | TradeSaleAction_Production_order_complete | TradeSaleAction_Ready_for_collection | TradeSaleAction_Collected | TradeSaleAction_Delivered | TradeSaleAction_Purchaser_invoiced | TradeSaleAction_Purchaser_paid | TradeSaleAction_Paid_organisation;

export interface TradeSaleActionOpts {
  cancelled: null;
  deleted: null;
  purchaser_accepted: (CollectionDetails|null);
  purchaser_rejected: null;
  delivery_order_requested: null;
  delivery_order_signed: null;
  production_order_complete: null;
  ready_for_collection: null;
  collected: common.LocalDate;
  delivered: common.LocalDate;
  purchaser_invoiced: common_db.DbKey<ferovinum_app_db.Invoice>;
  purchaser_paid: PurchaserPaymentInfo;
  paid_organisation: common.LocalDate;
}

export function makeTradeSaleAction<K extends keyof TradeSaleActionOpts>(kind: K, value: TradeSaleActionOpts[K]) { return {kind, value}; }

const TradeSaleAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.tradesale","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"cancelled","default":{"kind":"nothing"},"name":"cancelled","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"deleted","default":{"kind":"nothing"},"name":"deleted","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"purchaser_accepted","default":{"kind":"nothing"},"name":"purchaser_accepted","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.tradesale","name":"CollectionDetails"}},"parameters":[]}]}},{"annotations":[],"serializedName":"purchaser_rejected","default":{"kind":"nothing"},"name":"purchaser_rejected","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"delivery_order_requested","default":{"kind":"nothing"},"name":"delivery_order_requested","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"delivery_order_signed","default":{"kind":"nothing"},"name":"delivery_order_signed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"production_order_complete","default":{"kind":"nothing"},"name":"production_order_complete","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"ready_for_collection","default":{"kind":"nothing"},"name":"ready_for_collection","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"collected","default":{"kind":"nothing"},"name":"collected","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"delivered","default":{"kind":"nothing"},"name":"delivered","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaser_invoiced","default":{"kind":"nothing"},"name":"purchaser_invoiced","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Invoice"}},"parameters":[]}]}},{"annotations":[],"serializedName":"purchaser_paid","default":{"kind":"nothing"},"name":"purchaser_paid","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.tradesale","name":"PurchaserPaymentInfo"}},"parameters":[]}},{"annotations":[],"serializedName":"paid_organisation","default":{"kind":"nothing"},"name":"paid_organisation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"TradeSaleAction","version":{"kind":"nothing"}}};

export const snTradeSaleAction: ADL.ScopedName = {moduleName:"ferovinum.app.tradesale", name:"TradeSaleAction"};

export function texprTradeSaleAction(): ADL.ATypeExpr<TradeSaleAction> {
  return {value : {typeRef : {kind: "reference", value : snTradeSaleAction}, parameters : []}};
}

export interface CollectionDetails {
  collectionDate: common.LocalDate;
  collectionTime: common.LocalTime;
  collectorName: string;
  vehicleRegistration: (string|null);
  contactName: (string|null);
  contactNumber: (string|null);
}

export function makeCollectionDetails(
  input: {
    collectionDate: common.LocalDate,
    collectionTime: common.LocalTime,
    collectorName: string,
    vehicleRegistration: (string|null),
    contactName: (string|null),
    contactNumber: (string|null),
  }
): CollectionDetails {
  return {
    collectionDate: input.collectionDate,
    collectionTime: input.collectionTime,
    collectorName: input.collectorName,
    vehicleRegistration: input.vehicleRegistration,
    contactName: input.contactName,
    contactNumber: input.contactNumber,
  };
}

const CollectionDetails_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.tradesale","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"collectionDate","default":{"kind":"nothing"},"name":"collectionDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"collectionTime","default":{"kind":"nothing"},"name":"collectionTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"collectorName","default":{"kind":"nothing"},"name":"collectorName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"vehicleRegistration","default":{"kind":"nothing"},"name":"vehicleRegistration","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"contactName","default":{"kind":"nothing"},"name":"contactName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"contactNumber","default":{"kind":"nothing"},"name":"contactNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"CollectionDetails","version":{"kind":"nothing"}}};

export const snCollectionDetails: ADL.ScopedName = {moduleName:"ferovinum.app.tradesale", name:"CollectionDetails"};

export function texprCollectionDetails(): ADL.ATypeExpr<CollectionDetails> {
  return {value : {typeRef : {kind: "reference", value : snCollectionDetails}, parameters : []}};
}

export type BookingMethod = 'SKIP' | 'BOOK' | 'NET';
export const valuesBookingMethod : BookingMethod[] = ['SKIP', 'BOOK', 'NET'];

const BookingMethod_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.tradesale","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"SKIP","default":{"kind":"nothing"},"name":"SKIP","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"BOOK","default":{"kind":"nothing"},"name":"BOOK","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"NET","default":{"kind":"nothing"},"name":"NET","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"BookingMethod","version":{"kind":"nothing"}}};

export const snBookingMethod: ADL.ScopedName = {moduleName:"ferovinum.app.tradesale", name:"BookingMethod"};

export function texprBookingMethod(): ADL.ATypeExpr<BookingMethod> {
  return {value : {typeRef : {kind: "reference", value : snBookingMethod}, parameters : []}};
}

export interface PurchaserPaymentInfo {
  paymentDate: common.LocalDate;
  fxRate: (common.BigDecimal|null);
}

export function makePurchaserPaymentInfo(
  input: {
    paymentDate: common.LocalDate,
    fxRate: (common.BigDecimal|null),
  }
): PurchaserPaymentInfo {
  return {
    paymentDate: input.paymentDate,
    fxRate: input.fxRate,
  };
}

const PurchaserPaymentInfo_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.tradesale","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"paymentDate","default":{"kind":"nothing"},"name":"paymentDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"fxRate","default":{"kind":"nothing"},"name":"fxRate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}}]}},"name":"PurchaserPaymentInfo","version":{"kind":"nothing"}}};

export const snPurchaserPaymentInfo: ADL.ScopedName = {moduleName:"ferovinum.app.tradesale", name:"PurchaserPaymentInfo"};

export function texprPurchaserPaymentInfo(): ADL.ATypeExpr<PurchaserPaymentInfo> {
  return {value : {typeRef : {kind: "reference", value : snPurchaserPaymentInfo}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.tradesale.TradeSaleAction" : TradeSaleAction_AST,
  "ferovinum.app.tradesale.CollectionDetails" : CollectionDetails_AST,
  "ferovinum.app.tradesale.BookingMethod" : BookingMethod_AST,
  "ferovinum.app.tradesale.PurchaserPaymentInfo" : PurchaserPaymentInfo_AST
};
